import { Fragment } from 'react';
import { AccountingMappingIcon } from 'seagull/icons';
import { TableList, Tooltip, Typography } from 'seagull';
import { emptyCell } from "../../../constants";
import { Accounting } from "../../../types/api.model";
import { invoiceModel } from "../../../models";
import TimeActivityTooltip from "../../TimeActivityTooltip/TimeActivityTooltip";
import { getItemQBOTooltip, getXeroTooltip } from "../FullPageInvoice.utils";
import styles from "../FullPageInvoice.module.scss";
import { pathgen } from 'object-path-generator';
import InvoiceSubLineItems from "./InvoiceSubLineItems";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InvoiceLineItemsTableTestIds = pathgen('InvoiceLineItemsTableTestIds');
const firstColumnWidth = 400;
const columnDefs = [{
  width: firstColumnWidth,
  value: 'Description'
}, {
  width: 30,
  value: ''
},
// QBO indicator
{
  width: 30,
  value: ''
},
// Xero indicator
{
  width: [50, 60],
  hAlign: 'end',
  value: 'Quantity'
}, {
  width: [112, 120],
  hAlign: 'end',
  value: 'Rate'
}, {
  width: [80, 90],
  hAlign: 'end',
  value: 'Discount'
}, {
  width: [88, 104],
  hAlign: 'end',
  value: 'Total'
}];
const aCell = (contents, testid) => ({
  value: /*#__PURE__*/_jsx(Typography, {
    "data-testid": testid,
    children: contents
  })
});
export function qboIndicatorCell(_ref) {
  let {
    isGrouped,
    qbo,
    isVendor,
    getRowTestId
  } = _ref;
  return qbo && isVendor ? aCell( /*#__PURE__*/_jsxs("div", {
    className: styles.qboCellContainer,
    children: [qbo.timeActivity && /*#__PURE__*/_jsx("div", {
      "data-testid": getRowTestId('time-activity-linked'),
      children: /*#__PURE__*/_jsx(TimeActivityTooltip, {
        timeActivity: qbo.timeActivity,
        grouped: isGrouped
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: getItemQBOTooltip(qbo, getRowTestId('sync-tooltip')),
      children: /*#__PURE__*/_jsx("div", {
        "data-testid": getRowTestId('sync'),
        children: /*#__PURE__*/_jsx(AccountingMappingIcon, {
          size: 18
        })
      })
    })]
  })) : emptyCell;
}
function xeroIndicatorCell(_ref2) {
  let {
    item,
    isVendor,
    getRowTestId
  } = _ref2;
  return item.xero && isVendor ? aCell( /*#__PURE__*/_jsx(Tooltip, {
    title: getXeroTooltip({
      accounting: Accounting.Xero,
      itemName: item.xero.item.name,
      testid: getRowTestId('xero-sync-tooltip')
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.xeroCellContainer,
      "data-testid": getRowTestId('xero-sync'),
      children: /*#__PURE__*/_jsx(AccountingMappingIcon, {
        size: 18
      })
    })
  })) : emptyCell;
}
export default function InvoiceLineItemsTable(props) {
  const {
    invoice,
    isVendor
  } = props;
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  return /*#__PURE__*/_jsx(TableList.Provider, {
    variant: "minimal",
    columnDefs: columnDefs,
    justifyBetween: true,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.table,
      children: [/*#__PURE__*/_jsx(TableList.Header, {
        className: styles.tableHeader,
        bgColor: "darkGray",
        items: columnDefs
      }), /*#__PURE__*/_jsxs("div", {
        children: [invoice.items.map((item, idx) => {
          const getRowTestId = suffix => "fpi-row-".concat(idx, "-").concat(suffix);
          const subItems = item.subItems;
          return /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(TableList.Row, {
              size: "small",
              items: [aCell(invoiceModel.itemName(item), getRowTestId('name')), qboIndicatorCell({
                isGrouped: invoiceModel.isGrouped(item),
                qbo: item.qbo,
                isVendor,
                getRowTestId
              }), xeroIndicatorCell({
                item,
                getRowTestId,
                isVendor
              }), aCell(invoiceModel.itemQuantity(item), getRowTestId('quantity')), aCell(invoiceModel.itemRate(item), getRowTestId('rate')), aCell(invoiceModel.itemDiscount(item), getRowTestId('discount')), aCell(invoiceModel.itemTotalAmount(item), getRowTestId('total'))]
            }), item.note && /*#__PURE__*/_jsx(Typography, {
              "data-testid": getRowTestId('note'),
              skin: "secondary",
              variant: "paragraph2",
              className: styles.note,
              style: {
                width: firstColumnWidth
              },
              children: item.note
            }), subItems && isVendor && SERVICE_TEMPLATE_BUNDLE && subItems.map((subItem, subItemIdx) => /*#__PURE__*/_jsx(InvoiceSubLineItems, {
              isVendor: isVendor,
              subItem: subItem,
              quantity: invoiceModel.itemQuantity(item),
              disableMarginBottom: subItemIdx !== subItems.length - 1
            }, subItemIdx))]
          }, item.id);
        }), /*#__PURE__*/_jsx(TableList.Row, {
          className: styles.finalRow,
          size: "large",
          items: [emptyCell, emptyCell, emptyCell, emptyCell, aCell('Total'), aCell(invoiceModel.totalAmount(invoice))]
        })]
      })]
    })
  });
}